module.exports = __webpack_public_path__ + "static/media/news02.07601b4d.jpg";